module.exports = __webpack_public_path__ + "img/category-sport-hover.a086f27d.png";